import FhsCookie from "../../cookies";
import { FhsAuthAxios } from "./auth_instance";
// ---------------------------------------- ENDPOINTS
const AUTH = "/auth";
const AUTH_BY_USERNAME = `${AUTH}/login`;
const AUTH_BY_EDS = `${AUTH}/eds`;
const AUTH_REFRESH = `${AUTH}/refresh`;
export const FhsAuthApi = {
  loginByUsername(data) {
    return FhsAuthAxios.post(AUTH_BY_USERNAME, data);
  },
  loginByEds(data) {
    return FhsAuthAxios.post(AUTH_BY_EDS, data);
  },
  refreshToken() {
    let token_data = JSON.parse(FhsCookie.getItem("token_data") || null);
    let refresh_token_header = token_data
      ? `Bearer ${token_data.refresh_token}`
      : null;
    return FhsAuthAxios.post(
      AUTH_REFRESH,
      {},
      {
        headers: {
          Authorization: refresh_token_header
        }
      }
    );
  }
};
